/* eslint-disable */
// this is autogenerated code (we do not care about the linter)

import * as Types from "./types.graphql-gen";

import { gql } from "apollo-angular";
import { Injectable } from "@angular/core";
import * as Apollo from "apollo-angular";
export type EstimateSwapPricesQueryVariables = Types.Exact<{
	input: Types.EstimateSwapPricesInput;
}>;

export type EstimateSwapPricesQuery = {
	__typename?: "Query";
	estimateSwapPrices: {
		__typename?: "EstimateSwapPricesResponse";
		userJourney: string;
		appropriatenessTest: { __typename?: "AppropriatenessTest"; required: boolean; warning: boolean };
		source: {
			__typename?: "EstimateSwapPricesSource";
			toTargetRatio: string;
			min: { __typename?: "EstimateSwapPricesSourceRange"; asset: string; fiat: string };
			max: { __typename?: "EstimateSwapPricesSourceRange"; asset: string; fiat: string };
		};
		target: {
			__typename?: "EstimateSwapPricesTarget";
			toSourceRatio: string;
			forMinSource: string;
			forMaxSource: string;
		};
	};
};

export const EstimateSwapPricesDocument = gql`
	query estimateSwapPrices($input: EstimateSwapPricesInput!) {
		estimateSwapPrices(input: $input) {
			userJourney
			appropriatenessTest {
				required
				warning
			}
			source {
				min {
					asset
					fiat
				}
				max {
					asset
					fiat
				}
				toTargetRatio
			}
			target {
				toSourceRatio
				forMinSource
				forMaxSource
			}
		}
	}
`;

@Injectable({
	providedIn: "root"
})
export class EstimateSwapPricesGQLService extends Apollo.Query<
	EstimateSwapPricesQuery,
	EstimateSwapPricesQueryVariables
> {
	document = EstimateSwapPricesDocument;

	constructor(apollo: Apollo.Apollo) {
		super(apollo);
	}
}
